import styled, { css } from 'styled-components'

export const Label = styled.div`
  display: flex;
  gap: 1rem;
`

export const Text = styled.span<{ isRequired: boolean; withTooltip: boolean }>`
  display: block;
  position: relative;

  ${({ withTooltip }) =>
    withTooltip &&
    css`
      @media (max-width: 767px) {
        width: 17rem;
      }
    `}

  ${({ isRequired }) =>
    isRequired &&
    css`
      &:after {
        content: '*';
        color: #fb606d;
        position: relative;
        right: -0.3rem;
      }
    `}
`

export const Tooltip = styled.span`
  display: inline-block;
  width: 2rem;
  height: 2rem;
  position: absolute;
  right: -2.5rem;
  & div[class^='TooltipNewstyled__Content'] {
    color: #667399;
    box-shadow: 0 5px 20px 0 #00000021;
  }
  @media (max-width: 767px) {
    position: absolute;
    right: auto;
    left: 16rem;
  }
`
